import React from "react";
import { Link } from "react-router-dom";
import { FaBrain, FaHeadset, FaRocket, FaShieldAlt } from "react-icons/fa";

const UsHome = () => {
  const cardData = [
    { 
      icon: <FaBrain className="text-3xl text-red-600 mb-2" />, 
      title: "AI & ML Specialists",
      description: "Seasoned engineers in autonomous agent orchestration, RAG architectures, and fine-tuning."
    },
    { 
      icon: <FaRocket className="text-3xl text-red-600 mb-2" />, 
      title: "Rapid Deployment",
      description: "From concept to functional AI pipelines and production applications in days, not months."
    },
    { 
      icon: <FaHeadset className="text-3xl text-red-600 mb-2" />, 
      title: "24/7 Voice & Chat Support",
      description: "Round-the-clock automated and human assistance ensuring zero downtime for your systems."
    },
    { 
      icon: <FaShieldAlt className="text-3xl text-red-600 mb-2" />, 
      title: "Enterprise Grade Security",
      description: "Robust data privacy, strict guardrails, and compliance-ready AI implementations."
    },
  ];

  return (
    <div className="flex flex-col items-center justify-start max-w-7xl mt-16 sm:mt-20 md:mt-24 mx-auto px-4 w-full">
      <div className="flex flex-col gap-6 sm:gap-9 items-center justify-start w-full">
        <div className="w-[90%] md:w-[60%] m-auto text-center">
          <span className="text-red-600 font-semibold uppercase tracking-wider text-sm border-b-2 border-red-600 pb-1 inline-block mb-3">
            Why Core Spectators
          </span>
          <h2 className="my-2 font-bold text-center text-2xl sm:text-3xl lg:text-4xl text-gray-900">
            Why Choose Us for <span className="text-red-600">AI & Software Engineering</span>
          </h2>
          <p className="text-gray-600 text-center text-sm sm:text-base mt-3 leading-relaxed">
            We bridge the gap between breakthrough artificial intelligence and practical, revenue-generating business operations. Our solutions are built for speed, precision, and measurable ROI.
          </p>
        </div>

        {/* Grid layout for feature cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6 w-full">
          {cardData.map((card, index) => (
            <div
              key={index}
              className="shadow-lg hover:shadow-xl transition-all duration-300 rounded-2xl p-6 bg-white border border-gray-100 flex flex-col items-center text-center group hover:border-red-400"
            >
              <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mb-4 group-hover:scale-110 transition duration-200">
                {card.icon}
              </div>
              <h3 className="py-2 text-lg font-bold text-gray-900">
                {card.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>

        {/* Learn More button */}
        <div className="text-center mt-8 mb-8">
          <Link
            to="/Why-us"
            className="font-semibold rounded-xl text-center text-base sm:text-lg bg-red-600 hover:bg-red-700 text-white py-3 px-8 inline-block shadow-md transition"
          >
            Learn More About Our Methodology
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UsHome;
